import {PSEUDO_CITY} from '../productSearch/stationTypeConstants';

export default function(station_result) {
  let { result_type } = station_result;

  return result_type === PSEUDO_CITY ?
    station_result.sub_stations :
    [station_result];
}
